import { createReducer, on } from "@ngrx/store";
import { initialFeatureFamilyState } from "./feature-family.state";
import { UserActions } from "../../common/state/user/user.actions";
import { FeatureFamilyActions } from "./feature-family.actions";
import { onLoadableError, onLoadableLoad, onLoadableSuccess } from "../../common/models";
import { arrayToILoadableWrapperArray, createDefaultLoadable } from "../../common/models/loadable";
import { addFamily, clearFamilies, removeFamily, replaceFamily, resetFamilyLoading, setFamilyLoading } from "./helpers";

export const featureFamilyReducer = createReducer(
    initialFeatureFamilyState,
    on(FeatureFamilyActions.loadFamilies, state => ({
        families: onLoadableLoad({
            ...state.families
        })
    })),
    on(FeatureFamilyActions.loadFamiliesSuccess, (state, { families }) => ({
        families: onLoadableSuccess({
            ...state.families,
            items: arrayToILoadableWrapperArray(families)
        })
    })),
    on(FeatureFamilyActions.loadFamiliesFailure, (state, { error }) => ({
        families: onLoadableError({ ...state.families }, error)
    })),
    on(FeatureFamilyActions.clearFamilies, _ => ({
        families: {
            ...createDefaultLoadable(),
            items: clearFamilies()
        }
    })),

    on(FeatureFamilyActions.createFamily, state => ({
        families: onLoadableLoad(state.families)
    })),
    on(FeatureFamilyActions.createFamilySuccess, (state, { family }) => ({
        families: onLoadableSuccess({
            ...state.families,
            items: addFamily(state.families.items, family)
        })
    })),
    on(FeatureFamilyActions.createFamilyFailure, (state, { error }) => ({
        families: onLoadableError(state.families, error)
    })),

    on(FeatureFamilyActions.updateFamily, state => ({
        families: onLoadableLoad(state.families)
    })),
    on(FeatureFamilyActions.updateFamilySuccess, (state, { family }) => ({
        families: onLoadableSuccess({
            ...state.families,
            items: replaceFamily(state.families.items, family)
        })
    })),
    on(FeatureFamilyActions.updateFamilyFailure, (state, { error }) => ({
        families: onLoadableError(state.families, error)
    })),

    on(FeatureFamilyActions.deleteFamily, (state, { family }) => ({
        families: onLoadableLoad({
            ...state.families,
            items: setFamilyLoading(state.families.items, family)
        })
    })),
    on(FeatureFamilyActions.deleteFamilySuccess, (state, { family }) => ({
        families: onLoadableSuccess({
            ...state.families,
            items: removeFamily(state.families.items, family)
        })
    })),
    on(FeatureFamilyActions.deleteFamilyFailure, (state, { family, error }) => ({
        families: onLoadableError({
            ...state.families,
            items: resetFamilyLoading(state.families.items, family)
        }, error)
    })),

    on(UserActions.logout, _ => ({ ...initialFeatureFamilyState })),
);
